import { situationSteps } from './situation/situation.steps';
import { offerSteps } from './offer/offer.steps';
import { contractSteps } from './contract/contract.steps';
import { summarySteps } from './summary/summary.steps';

export const newQuotationSteps = [...situationSteps, ...offerSteps, ...contractSteps, ...summarySteps];
